import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/Services/Master/master.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SalService } from 'src/app/Services/sal/sal.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleorderviewmodelComponent } from '../saleorderviewmodel/saleorderviewmodel.component';
import { ConfirmationDialogService } from 'src/app/services/sal/confirmation-dialog.service';


@Component({
  selector: 'app-sale-order',
  templateUrl: './sale-order.component.html',
  styleUrls: ['./sale-order.component.css']
})
export class SaleOrderComponent implements OnInit {


  Submitted: boolean = false;
  Action: any = "Add";
  constructor(private modalService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    private router: Router, private salservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {


  }
  Pay(item) {
    this.confirmationDialogService.confirm('Please confirm..', 'Please click on OK to pay this order or Cancel to go back. ?')

      .then(confirmed => {
        if (confirmed) {
          window.localStorage.removeItem("ReceiptNo");
          window.localStorage.removeItem("razorpay_payment_id");
          window.localStorage.removeItem("razorpay_signature");
          window.localStorage.removeItem("razorpay_order_id");
          this.router.navigate(['/pay'], { state: { OrderNo: item.OrderNo } })
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  SearchModel = {
    SaleOrderID: 0,
    SchoolID: 0,
    BranchID: 0,
    ToDate: '',
    FromDate: '',
    OrderNo: '',
    InvoiceNo: '',
    CurrencyCode: '--- Select  ---',
    OrderStatusID: 0,
    CurrentIndex: 0,
    PageSize: 20
  };

  ClearSearch() {
    this.SearchModel.BranchID = 0;
    this.SearchModel.SchoolID = 0;
    this.SearchModel.OrderStatusID = 0;
    this.SearchModel.OrderNo = '';
    this.SearchModel.FromDate = '';
    this.SearchModel.ToDate = '';
    this.SearchModel.CurrencyCode = '--- Select  ---';
    this.SaleOrderList = [];
  }

  SaleOrderList = [];
  GetAllSaleOrder() {
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.spinnerService.show();
    this.salservice.GetAllSaleOrder(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.SaleOrderList = response.SaleOrderList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.recordCount = 0;
      if (response.SaleOrderList != null && response.SaleOrderList.length > 0) {
        this.recordCount = response.SaleOrderList[0].RecordCount;
      }
      this.numberOfPages();
    });
  };


  ItemList: any;
  Details: any;
  SumTotalTax: any;
  TotalAmount: any;
  OrderDetails: any;

  ViewSaleOrder(item) {

    this.OrderDetails = item;

    const modalRef = this.modalService.open(SaleorderviewmodelComponent, { size: 'xl' });
    modalRef.componentInstance.OrderDetails = this.OrderDetails;

    modalRef.result.then((result) => {
      if (result) {
        console.log(result);
      }
    });

  }

  ngOnInit() {    
    this.GetOrderStatus();    
    this.GetAllSaleOrder();
  }

 
  OrderStatusList: any;
  GetOrderStatus() {   
    this.lookupservice.GetLookupsList('OrderStatus','').subscribe((data: any) => {
      this.OrderStatusList = data.LookupItems;

    });
  };

  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }



  // Payment
 StudentPaymentModel = {
    FirstName: '',
    ChequeNo: "",
    ChequeDate: "",
    BankID: 0,
    StudentPhotoPath: "",
    Specialattention: "",
    Remarks: "",
    StudentID: 0,
    ClassID: 0,
    Amount: 0,
    PaidAmount: 0,
    RegistrationNumber: '',
    ReceiptNo: '',
    BankCharges: "",
    BankAccountID: 0,
    PaymentMode: "",
    MiddleName: "",
    ReferenceNo: "",
    razorpay_payment_id: '',
    razorpay_signature: '',
    razorpay_order_id: '',
    OrderNo: '',
    currency: '',
    Mobile: '',
    EmailID: '',
    key: ''
  }


  responseData: any;
  PaymentModel = {
    PGOrderNo: "",
    OrderNo: "",
    OrderAmount: 0,
    CurrencyCode: "",
    Key: "",
    Email: "",
    Mobile: '',
    CustomerName: "",
    CustomerID: 0,
    RefernceNo: "",
    Signature: "",
    ReceiptNo: "",
    CurrencyRate: ""
  };
 
}



